export {default as AdministrativosList} from './List'
export {default as AdministrativosCrear} from './Create'
